import { render, staticRenderFns } from "./LeccionD6.vue?vue&type=template&id=59821158&"
import script from "./LeccionD6.vue?vue&type=script&lang=js&"
export * from "./LeccionD6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports